import { APPLY_COUPON, COUPON_ERROR, REMOVE_ONE_COUPON, CLEAR_PENDING_APPLIED_COUPON } from "./actionTypes";
import { APPLY_COUPON_URL, GET_COUPONS } from "../../configs";
import Axios from "axios";

export const applyCoupon = (token, coupon, restaurant_id, subtotal) => (
  dispatch
) => {
  return Axios.post(APPLY_COUPON_URL, {
    token: token,
    coupon: coupon,
    restaurant_id: restaurant_id,
    subtotal: subtotal,
  })
    .then((response) => {
      const data = response.data;
      // Ensure vendor coupons are keyed by restaurant_id (backend may omit it on older versions)
      if (data && data.success && data.restaurant_id == null && restaurant_id != null) {
        data.restaurant_id = restaurant_id;
      }
      dispatch({ type: APPLY_COUPON, payload: data });
      dispatch({ type: COUPON_ERROR, payload: null });
      // Return data so callers can wait for success and navigate only when applied (e.g. CouponList)
      return data;
    })
    .catch(function(error) {
      if (error.response && error.response.status === 401) {
        dispatch({ type: COUPON_ERROR, payload: "NOTLOGGEDIN" });
      }
      return Promise.reject(error);
    });
};

function clearStoredCouponState() {
  try {
    if (typeof localStorage !== "undefined") localStorage.removeItem("appliedCoupon");
    if (typeof sessionStorage !== "undefined") {
      sessionStorage.removeItem("cart_applied_coupon_payload");
      sessionStorage.removeItem("cart_return_from_coupon");
    }
  } catch (e) {}
}

export const removeCoupon = () => (dispatch) => {
  clearStoredCouponState();
  const coupon = { hideMessage: true, coupon_error: "" };
  return dispatch({ type: APPLY_COUPON, payload: coupon });
};

/** Remove one vendor coupon by restaurant_id, or the platform (Zaaapit) coupon. */
export const removeOneCoupon = (key) => (dispatch) => {
  clearStoredCouponState();
  if (key === "elevate" || key === "ELEVATE") {
    return dispatch({ type: REMOVE_ONE_COUPON, payload: "elevate" });
  }
  const rid = typeof key === "number" ? key : Number(key);
  if (!Number.isNaN(rid)) {
    return dispatch({ type: REMOVE_ONE_COUPON, payload: rid });
  }
};

export const couponApplied = (coupon, percentage_discount) => (dispatch) => {
  coupon.appliedAmount = percentage_discount;
  return dispatch({ type: APPLY_COUPON, payload: coupon });
};

/** Apply coupon from an already-fetched payload (e.g. from navigation state). No API call. */
export const applyCouponFromPayload = (payload) => (dispatch) => {
  if (payload && payload.success) {
    dispatch({ type: APPLY_COUPON, payload });
    dispatch({ type: COUPON_ERROR, payload: null });
  }
  return Promise.resolve();
};

export const clearPendingAppliedCoupon = () => (dispatch) => {
  dispatch({ type: CLEAR_PENDING_APPLIED_COUPON });
};

/**
 * Fetch coupons for one or more restaurants, or universal coupons when no store.
 * @param {number|number[]|null|undefined} restaurantIdOrIds - Single ID (Sprint), array of IDs (Relay), or null/empty for universal-only
 * @param {string} token - Auth token
 * @returns {Promise<{ success: boolean, coupons: array }>} Backend returns store-linked + universal when store(s) provided; universal-only when none.
 */
export const getCouponList = async (restaurantIdOrIds, token) => {
  const payload = { token };
  const isArray = Array.isArray(restaurantIdOrIds);
  if (isArray && restaurantIdOrIds.length > 0) {
    payload.restaurant_ids = restaurantIdOrIds.map((id) => Number(id)).filter((id) => !Number.isNaN(id));
  } else if (!isArray && restaurantIdOrIds != null && restaurantIdOrIds !== "") {
    payload.restaurant_id = Number(restaurantIdOrIds);
  }
  try {
    const response = await Axios.post(GET_COUPONS, payload);
    return response.data || { success: false, coupons: [] };
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};
